module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/chicken-pic.79693d27.png";